// extracted by mini-css-extract-plugin
export default {"ClientUploadPage":"ClientUploadPage_ClientUploadPage__uIQNR","file":"ClientUploadPage_file__B60nt","loader":"ClientUploadPage_loader__5bxx7"};